import { FaBuilding, FaPhone, FaEnvelope, FaExpand, FaPlug, FaMapMarkerAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

import images from "./images";
const Venue = {
    googleMap: {
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4233273998598!2d121.60476630000001!3d25.0536372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442ab5e0481f73d%3A0xd45012a70ff13733!2z55O26JOL5bel5bug5Y-w5YyX6KO96YCg5omA!5e0!3m2!1szh-TW!2stw!4v1745564093989!5m2!1sen!2stw",
        allowFullScreen: true,
        loading: "lazy"
    },
    venueInfo: {
        sub: "競賽場地導覽",
        heading: "場地資訊訊息",
        points: [
            { icon: <FaBuilding />, title: "地點", description: "南港瓶蓋工廠 POPOP TAIPEI" },
            { icon: <FaLocationDot />, title: "地址", description: "115028 台北市南港區南港路二段13號" },
            // { icon: <FaPhone />, title: "Contact Number", description: "" },
            // { icon: <FaEnvelope />, title: "Email Address", description: "" }
        ]
    },
    venueGallery: [
        images.venueGallery1,
        images.venueGallery2,
        images.venueGallery3,
    ],
    venueFeatures: [
        // { icon: <FaExpand />, title: "Spacious Layout", description: "Experience a generously sized venue designed to enhance attendee comfort and engagement." },
        // { icon: <FaPlug />, title: "Modern Amenities", description: "Enjoy state-of-the-art facilities, including high-speed Wi-Fi and audio-visual equipment." },
        // { icon: <FaMapMarkerAlt />, title: "Prime Location", description: "Conveniently situated in the heart of the city, easily accessible by public transport." }
    ],
    hotelRooms: {
        sub: "We're Here to Help!",
        heading: "Book Your Hotel Room",
        rooms: [
            { src: images.venueRoom1, alt: "Standard Room", title: "Standard Room", price: "$90/per night" },
            { src: images.venueRoom2, alt: "Deluxe Room", title: "Deluxe Room", price: "$120/per night" },
            { src: images.venueRoom3, alt: "Executive Suite", title: "Executive Suite", price: "$180/per night" }
        ]
    }
};

export default Venue;